module.exports = {
	"base": {
		"welcome": "Velkomin til Mulligan, %{name}!",
		"user": "Notandaupplýsingar",
		"devices": "Áhöld",
		"refunds": "Endurgreiðslur",
		"resources": "Heimildir",
		"transactions": "Pantanir og skil",
		"email": "Netfang",
		"password": "Lykilorð",
		"save": "Vista",
		"sign-out": "Skrá út",
		"cancel": "Hætta við",
		"close": "Loka",
		"learn-more": "Fáðu að vita meira",
		"required": "Krafist",
		"support": "Stuðningur",
		"bookshelf": "Bookshelf",
		"launch": "Setja af stað",
		"download": "Sækja",
		"details": "Upplýsingar",
		"cannot-be-blank": "%{field} má ekki vera autt.",
		"saving": "Vista...",
		"done": "Lokið",
		"failed": "Mistókst",
		"copy": "Afrita"
	},
	"signin": {
		"login-failure": "Netfang eða aðgangsorð er ekki rétt",
		"welcome-large": "Velkomin í <span class='inner'>%{brand} reikningaþjónustu</span>",
		"welcome-small": "<span class='inner'>Reikningsþjónusta</span>",
		"signin-button": "Skrá inn",
		"forgot-password": "Gleymdirðu laðgangsorðinu",
		"new-to-vst": "Ertu ný(r) í %{brand}?",
		"create-account": "Stofna reikning",
		"signing-in": "Innskráning...",
		"signin-failed": "Innskráning mistókst"
	},
	"transactions": {
		"price": "Verð",
		"excluded": "(Fyrir utan skatt)",
		"quantity": "Fjöldi",
		"confirmation#": "Staðfestingarnr.",
		"payment": "Greiðsla",
		"purchased": "Keypt",
		"purchase-details": "Upplýsingar um kaup",
		"subtotal": "Millisamtala",
		"total": "Samtals",
		"tax": "Skattur",
		"loading": "Halló eyðslukló, við erum að sækja færslurnar þínar...",
		"no-purchases": "Það eru engin kaup.",
		"seller-vat": "VSK seljanda",
		"total-vat": "Samtals %{vat} greiddur",
		"portion": "%{subTax} skattur %{rate}%",
		"vat-disclosure": "Innifalið í verði %{vat}",
		"purchases": "Kaup",
		"refunded-items": "Endurgreiddar vörur",
		"book-title": "Bókartitill",
		"refund-details": "Upplýsingar um endurgreiðslu",
		"print-receipt": "Prenta kvittun",
		"request-refund": "Biðja um endurgreiðslu",
		"expired": "Útrunnið",
		"expires-in": "Rennur út %{date}",
		"details-refund": "Upplýsingar og endurgreiðsla",
		"modal": {
			"cant-refund-title": "Engin endurgreiðsla tiltæk",
			"cant-refund": "Ekki er hægt að endurgreiða bókina vegna einnar eða fleiri af eftirfarandi ástæðum.",
			"cant-refund-1": "Búið er að skoða of stóran hluta bókarinnar.",
			"cant-refund-2": "Það eru liðnir meira en 14 dagar frá kaupdegi.",
			"cant-refund-3": "Aðfangakóðinn þinn á netinu hefur verið birtur.",
			"cant-refund-4": "Bókin hefur áður verið endurgreidd.",
			"cant-refund-5": "Allir kóðar hafa verið innleystir og/eða endurgreiddir.",
			"cant-refund-6": "Það eru liðnir meira en 30 dagar frá kaupdegi.",
			"cant-refund-support": "Ef þú ert enn í vafa um endurgreiðslustefnu %{brand}, skaltu hafa samband við <a href='%{support_url}' target='_blank'>þjónustuna</a>."
		},
		"license": {
			"perpetual": "Aðgangur á netinu rennur ekki út",
			"days": "%{days} aðgangsdagur(-dagar)"
		}
	},
	"devices": {
		"description": "%{brand} gerir þér kleift að vera með <span>%{desktop}</span> tölvur og <span>%{mobile}</span> farsíma/spjaldtölvur virk á sama tíma.",
		"loading": "Hæ, við erum að sækja tækin þín :)",
		"no-active": "Þú ert ekki með nein virk tæki.",
		"deactivate": "Afvirkja"
	},
	"user": {
		"personal-information": "Persónuupplýsingar",
		"security-information": "Öryggisupplýsingar",
		"notifications": "Tilkynningar",
		"first-name": "Fornafn",
		"last-name": "Eftirnafn",
		"change-password-title": "Breyta lykilorði",
		"current-password": "Núverandi aðgangsorð",
		"new-password": "Nýtt lykilorð",
		"security-password": "Lykilorð",
		"confirm-new-password": "Staðfesta nýtt lykilorð",
		"security-question": "Öryggisspurning",
		"security-info-change": "Breyta",
		"question": "Spurning",
		"answer": "Svar",
		"notifications-text": "Sendið mér með tölvupósti stöku uppfærslur um virkni á reikningi mínum, uppfærslur á vörum og tilboð.",
		"loading": "Spot er að sækja notandaupplýsingar þínar, bíddu aðeins 🐶",
		"change-password-text": "Aðgangsorðið verður að vera minnst átta stafir að lengd og innihalda minnst einn hástaf, einn lágstaf og eitt sértákn.",
		"email-locked": "Netfang læst",
		"email-locked-description": "Þú hefur ekki aðgang til að breyta netfanginu þínu.",
		"email-locked-more": "Hafðu sambandi við stjórnandann.",
		"security-question6": "Hver er uppáhalds íþróttin þín?",
		"security-question7": "Hver er uppáhalds ísinn þinn?",
		"security-question8": "Hvað heitir uppáhalds gæludýrið þitt?",
		"security-question9": "Þegar þú varst yngri, hvað langaði þig til að verða þegar þú yrðir stór?",
		"security-question10": "Hvað hét uppáhalds kennarinn þinn?",
		"new-password-failure": "Aðgangsorðið uppfyllir ekki kröfur",
		"confirm-password-failure": "Aðgangsorðin verða að stemma",
		"new-password-tooltip": "Verður að vera minnst 8 stafir, með hástaf, lágstaf og sértákn.",
		"enter-valid-email": "Sláðu inn gilt netfang.",
		"password-cannot-be-same": "Aðgangsorðið getur ekki verið það sama og fyrri aðgangsorð",
		"incorrect-password": "Rangt aðgangsorð",
		"complete-account": "Þú þarft að <a href='%{href}'>ljúka við skráninguna</a>.",
		"completing-allows": "Með því að ljúka skráningunni getur þú lesið bækur án nettengingar með smáforritum okkar fyrir fartæki og deilt athugasemdum og áherslumerkingum með vinum þínum.",
		"error-updating-info": "There was an error updating your information.",
		"password-updated": "Password successfully updated",
		"security-updated": "Security question successfully updated",
		"info-updated": "User information successfully updated"
	},
	"resources": {
		"ancillaries": "Stoðskrár",
		"access-codes": "Aðgangskóðar",
		"print-on-demand": "Prenta eftir þörfum",
		"check-pod": "Athugaðu prentvalkosti útgefanda fyrir bækurnar þínar.",
		"check-now": "Athuga núna",
		"loading": "Dokaðu við, við erum að uppfæra aðföngin þín!",
		"in": "í",
		"access-code-intro": "Aðgangskóði er aðgangsorð sem þú notar til að fá aðgang að efni námskeiðs á netinu. Once you reveal a code for an item, you will not be able to return it. Til að fá nánari upplýsingar um hvernig nota skuli aðgangskóðann, skal fara í <a href='%{support_url}' target='_blank'>hjálpina</a>.",
		"expires": "Rennur út",
		"expiration-message": "Inniheldur leiðbeiningar um notkun aðgangskóðans.",
		"copy-fail": "Ekki hægt að afrita. Veldu kóðann og afritaðu hann handvirkt.",
		"launch-site": "Setja af stað vefsetur",
		"launch-book": "Setja af stað Book",
		"reveal-code": "Sýna kóða",
		"no-resources": "Þú ert ekki með nein aðföng.",
		"no-access-codes": "Þú ert ekki með neina aðgangskóða.",
		"no-ancillaries": "Ekkert auka fyrir þennan titil",
		"name": "Heiti",
		"type": "Tegund",
		"size": "Stærð",
		"download-all": "Hala niður allt",
		"back": "Til baka í tilföng"
	},
	"refunds": {
		"states": {
			"refunded": "Endurgreitt",
			"unavailable": "Endurgreiðsla ekki tiltæk"
		},
		"reasons": {
			"dropped": "Ég hætti í námskeiðinu",
			"wrong": "Þetta var ekki rétt bók fyrir námskeiðið mitt",
			"print": "Ég ákvað að kaupa heldur prentaða útgáfu",
			"missing": "Bókin inniheldur ekki allt sem ég þarf fyrir námskeiðið (t.d. geisladisk, netaðgang, myndbönd)",
			"other": "Annað"
		},
		"bulk": {
			"policy": "Með því að smella á „Ljúka endurgreiðslu“ hnappinn hér fyrir neðan, samþykki ég %{brand} <a href='%{policy_url}' target='_blank'>endurgreiðslustefnuna</a>.",
			"complete": "Klára endurgreiðslu",
			"view-details": "Skoða upplýsingar um endurgreiðslu",
			"success": "Beiðni þín um endurgreiðslu hefur verið send. Úrvinnsla getur tekið allt að 48 klukkustundir.",
			"failure": "Æ - eitthvað fór úrskeiðis! Því miður tókst endurgreiðslan ekki.",
			"retry": "Reyndu aftur",
			"support": "Fáðu aðstoð",
			"available-codes": "Tiltækir kóðar",
			"codes-selected": "Valdir kóðar",
			"download": "Sækja kóða",
			"partially-refunded": "Endurgreitt að hluta",
			"pick-one": "Þú þarft að velja minnst einn kóða til að fá endurgreiðslu"
		},
		"refund": "Endurgreiðsla",
		"all": "Endurgreiða allt?",
		"missing-reason": "Þú þarft að velja ástæðu til að halda áfram",
		"missing-elaboration": "Skýrðu nánar",
		"policy": "Með því að smella á „Ljúka beiðni um endurgreiðslu“ hnappinn hér fyrir neðan, hef ég skilið að ef ég kaupi þessa %{brand} rafbók aftur, mun ég ekki uppfylla skilyrði til að biðja um frekari endurgreiðslu fyrir sömu rafbókina. Skoða heildarskilmála um vöruskil.",
		"refunded": "Endurgreitt",
		"sorry": "Við hörmum að þú hafir ekki verið ánægð(-ur) með kaupin.",
		"error": "Eitthvað fór úrskeiðis",
		"error-explain": "Ekki tókst að vinna úr endurgreiðslunni. Reyndu aftur síðar.",
		"why": "Segðu okkur hvers vegna?",
		"no-refunds": "Þú ert ekki með neitt endurgreitt.",
		"select-codes": "Veldu kóða til að endurgreiða:",
		"number": "Hversu marga?",
		"back": "Til baka í endurgreiðslur"
	},
	"purchases": {
		"back": "Til baka í innkaup"
	},
	"global-bar": {
		"account": "Stillingar reiknings"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/locales/is.json
 ** module id = 1012
 ** module chunks = 0
 **/